import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Clock"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
  selector: 'app-icon-clock',
  templateUrl: './icon-clock.component.html',
  styleUrls: ['./icon-clock.component.scss'],
  standalone: false,
})
export class IconClockComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
